import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Card } from "../ui/card";
import { SRStatoBadge } from "../portal/SRForm";
import { formatDateTime } from "../../lib/format";
import { Hospital } from "lucide-react";

export const StruttureCard = ({ onOpen }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const load = () => api.get("/strutture/richieste", { params: { aperte: true } }).then(({ data }) => setItems(data)).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, []);
  const daPrendere = items.filter((r) => r.stato === "ricevuta").length;
  return (
    <Card data-testid="strutture-card" className={`p-5 ${daPrendere > 0 ? "border-amber-300 bg-amber-50/60" : "border-slate-200"}`}>
      <div className="flex items-center justify-between">
        <p className="nx-label">Da prendere in carico</p>
        <Hospital className="h-4 w-4 text-primary" />
      </div>
      <p data-testid="strutture-card-count" className="text-3xl font-bold font-heading mt-1 text-amber-700">{daPrendere}</p>
      <p className="text-[11px] text-slate-500 mt-0.5">richieste dal Portale Strutture{items.length > daPrendere && ` · ${items.length - daPrendere} in lavorazione`}</p>
      {items.length > 0 && (
        <ul className="mt-3 space-y-1.5 border-t border-slate-200 pt-2 max-h-40 overflow-auto">
          {items.map((r) => (
            <li key={r.id}>
              <button type="button" data-testid={`strutture-item-${r.id}`} onClick={() => onOpen(r)}
                className="w-full text-left text-xs hover:opacity-80">
                <span className="flex items-center justify-between gap-2"><span className="font-mono font-semibold text-primary">{r.code}</span><SRStatoBadge stato={r.stato} /></span>
                <span className="block truncate text-slate-500">{r.struttura_nome} · {formatDateTime(r.data_ora_carico)}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
};
